// extracted by mini-css-extract-plugin
module.exports = {"Search":"tableStyles_Search__3ztnQ","btn_1":"tableStyles_btn_1__1k3dP","btn_2":"tableStyles_btn_2__1BZg0","btn_3":"tableStyles_btn_3__2Sf13","btn_4":"tableStyles_btn_4__3ZdlA"};